<template>
  <div id="header_top">
    <div id="edit_message">
      <el-form :model="ruleForm" ref="ruleForm" label-width="100px"  :inline="true">
        <el-form-item label="填报单位：" prop="cjr">
          <el-input v-model="ruleForm.tbDw" size="mini"  placeholder="填报单位" :readonly="true"></el-input>
        </el-form-item>
        <el-form-item label="月报时间：" prop="ptDate">
          <el-input v-model="ruleForm.ptDate" size="mini" placeholder="月报时间"  :readonly="true"></el-input>
        </el-form-item>
        <el-form-item label="填报人：" prop="tbTbr">
          <el-input v-model="ruleForm.tbTbr" size="mini" placeholder="填报人" :readonly="true"></el-input>
        </el-form-item>
        <el-form-item label="联系电话：" prop="tbTel">
          <el-input v-model="ruleForm.tbTel" size="mini" placeholder="联系电话"  :readonly="true"></el-input>
        </el-form-item>
        <el-form-item label="责任人：" prop="tbDwfzr">
          <el-input v-model="ruleForm.tbDwfzr" size="mini" placeholder="单位责任人" :readonly="true" ></el-input>
        </el-form-item>
        <el-form-item label="填报时间：" prop="tbDate">
          <el-input v-model="ruleForm.tbDate" size="mini" :readonly="true"></el-input>
        </el-form-item>
        <el-form-item label="征收标准:" prop="zsbz" id="last_input"  style="width:600px">
          <el-input  v-model="ruleForm.zsbz" type="textarea" placeholder="征收标准(元/平方)：" size="mini" :readonly="true"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="flex_dialog">
      <el-row :gutter="2" type="flex" class="row-bg" justify="space-around">
        <el-col :span="3"><div class="grid-content bg-purple">指标名称</div></el-col>
        <el-col :span="2"><div class="grid-content bg-purple">计量单位</div></el-col>
        <el-col :span="2"><div class="grid-content bg-purple">本月实际</div></el-col>
        <el-col :span="6"><div class="grid-content bg-purple">{{date1}}</div></el-col>
        <el-col :span="4"><div class="grid-content bg-purple">上年同期累计数</div></el-col>
        <el-col :span="5"><div class="grid-content bg-purple">与去年同期比(-+%)</div></el-col>
        <el-col :span="10"><div class="grid-content bg-purple">备注</div></el-col>
      </el-row>
      <el-row :gutter="2" type="flex" class="row-bg" justify="space-around" v-for="(item,index) in indexList" :key="index">
        <el-col  style="display: none"><div class="grid-content bg-purple">{{item.recode_id}}</div></el-col>
        <el-col :span="3"><div class="grid-content bg-purple">{{item.index_name}}</div></el-col>
        <el-col :span="2"><div class="grid-content bg-purple">{{item.index_dw}}</div></el-col>
        <el-col :span="2"><div class="grid-content bg-purple">{{item.bysjtb}}</div></el-col>
        <el-col :span="6"><div class="grid-content bg-purple">{{item.sun}}</div></el-col>
        <el-col :span="4"><div class="grid-content bg-purple" >{{item.sntqljs}}</div></el-col>
        <el-col :span="5"><div class="grid-content bg-purple">{{item.tongwi}}</div></el-col>
        <el-col :span="10"><div class="grid-content bg-purple">{{item.bz}}</div></el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
  import axios from '@/utils/axios.js'
  import util from '@/utils/util.js'
  export default {
    name: "search",
    data(){
      return {
        tongwi:'',
        value1: '',
        state: '',
        date1:'',
        indexList: [],
        ruleForm:{
          tbDw:'',
          ptDate:'',
          tbTbr:'',
          tbTel:'',
          tbDwfzr:'',
          tbDate:'',
          bz:''
        },
      }
    },

    mounted(){
      this.gainDate1();
    },
    methods:{
      gainDate1(){//列表当前月份获取
        let _this = this;
        var myDate = new Date();
        _this.date1=util.formatDate(myDate,"MM");

      },
      LoopListItem(){ //生成填报列表
        let _this = this
        axios.post('/base/audit/checkIndex').then(function(res){
          var data=res.data.data;
          data.forEach(elment=>{
            elment['bysjtb'] = 0;
            elment['sntqljs'] = 0;
            elment['indexId'] = elment.id;
          });
          _this.indexList =[...data];
        })
      },

      examine(index,row){ //查看按钮获取数据方法
        let _this = this
        axios.post('/base/audit/checkaudit',{buinessId:row.id}).then(function(res){
          var data=res.data.data;
          _this.indexList = data.list;
          _this.ruleForm = data.business;
          _this.ruleForm.tbDate = util.formatDate(new Date(row.tb_date),"yyyy-MM-dd");
          if (data.list[0].sp_spyj ===0 ){
            var time=data.business.ptDate;
            var year=  time.substring(0,4);
            var month=time.substring(4)
            var  newmouth=parseInt(month)
            var  newyear=parseInt(year)
            var month1=newmouth+1;
            if (month1===0){
              month1=12;
              newyear=year-1;
            }
            _this.date1=newyear+"年1月-"+month1+"月累积";
          }else {
          var time=data.business.ptDate;
          var year=  time.substring(0,4);
          var month=time.substring(4)
          _this.date1=year+"年1月-"+month+"月累积";
          }
        })
      },


    }
  }
</script>

<style   scoped>
  #header_top{
    height:490px;
    overflow: auto;
  }
  .flex_dialog{
  /*  height:365px;*/
    width:99.2%;
    border:1px solid #000;
   /* overflow-y:scroll;*/
  }

  .el-row {
    margin-bottom:2px;
  }


  #header_header{
    display: flex;
    flex-wrap:nowrap;
    justify-content:space-between;
    margin-bottom: 10px;
  }
  .el-form-item{
    width:320px;
  }
  #last_input{
    width:600px;
  }
  .el-col {
    border-radius: 4px;
  }
  bg-purple-dark {
    background: #99a9bf;
  }
  .bg-purple {
    background: #d3dce6;
  }
  input{
    width:100px;
  }
  textarea{
    width:700px;
    height:18px;
  }
  bg-purple-light {
    /*background: #e5e9f2;*/
  }
  .grid-content {
    border-radius: 1px;
    min-height: 30px;
    text-align:center;
    line-height: 32px;
  }
  row-bg {
    padding: 10px 0;
    /* background-color: #f9fafc;*/
  }
</style>



// WEBPACK FOOTER //
// src/views/common/edit/search.vue